var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgComplexCircleShapes03(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 31,
    height: 31,
    viewBox: "0 0 31 31",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_173_112)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M29.0146 12.223C30.8325 19.686 26.2399 27.1968 18.7769 29.0147C11.314 30.8326 3.77925 26.24 1.98527 18.777C0.167368 11.3141 4.75996 3.80325 12.2229 1.98535C19.6859 0.167444 27.2206 4.76004 29.0146 12.223Z",
    stroke: "white",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18.5854 14.7346C20.6186 23.1065 20.8817 30.2585 19.1595 30.6651C17.4373 31.0718 14.4234 24.6134 12.3663 16.2415C10.3331 7.86959 10.07 0.717587 11.7683 0.310951C13.4905 -0.0956851 16.5044 6.36265 18.5615 14.7346H18.5854Z",
    stroke: "white",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.2417 18.5857C7.86981 20.6188 0.7178 20.8819 0.311164 19.1836C-0.0954715 17.4614 6.36286 14.4475 14.7348 12.3904C23.1067 10.3573 30.2587 10.0941 30.6653 11.7924C31.072 13.5147 24.6136 16.5286 16.2417 18.5857Z",
    stroke: "white",
    strokeMiterlimit: 10
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_173_112"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 31,
    height: 31,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgComplexCircleShapes03);
export default __webpack_public_path__ + "static/media/complexCircleShapes03.cfb86c4829a0b74355e1f5b238b5f7e3.svg";
export { ForwardRef as ReactComponent };